<script>
    import { to_currency } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/currency.js?1733898724803';

    export let count = 0;
    export let sum;
    export let locale;
    export let currency;

    $: sum_text = sum != null ? to_currency(sum, locale, currency) : '-';
</script>
<!--
<p class="title"><b>{window.__('cart.name')}</b></p>
-->
<p class="items">{@html window.__('cart.items_in_cart', { count })}</p>
<p class="sum">Gesamtsumme: <b>{sum_text}</b></p>


<style>
    p {
        padding: 0;
        margin: 0 0 0.2rem;
    }
   .sum{
    border-top: 1px solid var(--color-text);
   }
   .sum > b{
    font-size: 1.5rem !important;
   }
</style>